export default __webpack_public_path__ + "static/media/conferenceroom.259da138.jpg";